export { default as TabPane } from './tab-pane';
export { default as TabContent } from './tab-content';
